import { StoreCurrency } from "../services/store.service";

export default function(value) {
    return StoreCurrency.format(value);
};